/**
 * Horizontal carousel scroll: native touch/trackpad + mouse drag on desktop.
 * Touch uses native scroll; links stay clickable unless the user actually dragged/scrolled.
 */
function initCarouselScroll(list, options = {}) {
  if (!list || list.dataset.carouselScrollInit === 'true') {
    return;
  }

  list.dataset.carouselScrollInit = 'true';

  const draggingClass = options.draggingClass || 'carousel-scroll--dragging';
  const ignoreSelector =
    options.ignoreSelector ||
    'button, input, select, textarea, add-to-cart, quick-buy-button, [data-real-life-video-carousel-toggle]';
  const onScroll = typeof options.onScroll === 'function' ? options.onScroll : null;
  const DRAG_THRESHOLD = 10;

  let activePointerId = null;
  let startX = 0;
  let startScrollLeft = 0;
  let hasDragged = false;
  let suppressClick = false;
  let touchMoved = false;
  let touchStartX = 0;
  let touchStartY = 0;

  if (onScroll) {
    list.addEventListener('scroll', onScroll, { passive: true });
  }

  list.addEventListener('dragstart', (event) => event.preventDefault());

  list.addEventListener(
    'click',
    (event) => {
      if (!suppressClick) {
        return;
      }

      suppressClick = false;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  list.addEventListener(
    'touchstart',
    (event) => {
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
      touchMoved = false;
    },
    { passive: true }
  );

  list.addEventListener(
    'touchmove',
    (event) => {
      if (
        Math.abs(event.touches[0].clientX - touchStartX) > 8 ||
        Math.abs(event.touches[0].clientY - touchStartY) > 8
      ) {
        touchMoved = true;
      }
    },
    { passive: true }
  );

  list.addEventListener(
    'touchend',
    () => {
      if (!touchMoved) {
        return;
      }

      suppressClick = true;
      touchMoved = false;
      window.setTimeout(() => {
        suppressClick = false;
      }, 350);
    },
    { passive: true }
  );

  list.addEventListener('pointerdown', (event) => {
    if (event.pointerType === 'touch') {
      return;
    }

    if (event.button !== 0 || !event.isPrimary) {
      return;
    }

    if (event.target.closest(ignoreSelector)) {
      return;
    }

    activePointerId = event.pointerId;
    startX = event.clientX;
    startScrollLeft = list.scrollLeft;
    hasDragged = false;
  });

  list.addEventListener('pointermove', (event) => {
    if (event.pointerId !== activePointerId || event.pointerType === 'touch') {
      return;
    }

    const distance = event.clientX - startX;

    if (!hasDragged && Math.abs(distance) > DRAG_THRESHOLD) {
      hasDragged = true;
      list.classList.add(draggingClass);

      if (list.setPointerCapture) {
        list.setPointerCapture(event.pointerId);
      }
    }

    if (hasDragged) {
      event.preventDefault();
      list.scrollLeft = startScrollLeft - distance;
      onScroll?.();
    }
  });

  list.addEventListener('pointerup', endPointer);
  list.addEventListener('pointercancel', endPointer);

  function endPointer(event) {
    if (event.pointerId !== activePointerId) {
      return;
    }

    if (hasDragged) {
      suppressClick = true;
      window.setTimeout(() => {
        suppressClick = false;
      }, 0);
    }

    list.classList.remove(draggingClass);

    if (list.hasPointerCapture?.(event.pointerId)) {
      list.releasePointerCapture(event.pointerId);
    }

    activePointerId = null;
    hasDragged = false;
    onScroll?.();
  }
}

window.initCarouselScroll = initCarouselScroll;
